import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

/* istanbul ignore file */
interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconMailDefault(
  { srText, size = 'md', className = '', ...props }: Props,
) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={25}
        fill='none'
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <path
          fill='currentColor'
          d='M3.111 18.93v-7.5l7.712 4.647c.72.434 1.635.434 2.355 0l7.712-4.647v7.5z'
        />
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M2.572 10.49a1.15 1.15 0 0 1 1.128.028l7.711 4.648c.36.217.818.217 1.178 0l7.711-4.648a1.15 1.15 0 0 1 1.128-.028c.353.189.572.547.572.937v7.5C22 19.52 21.504 20 20.89 20H3.11c-.614 0-1.111-.48-1.111-1.072v-7.5c0-.39.22-.748.572-.937m17.206 2.87-6.011 3.623a3.44 3.44 0 0 1-3.533 0L4.222 13.36v4.496h15.556z'
          clipRule='evenodd'
        />
        <path
          fill='currentColor'
          d='M11.706 11.25 3.111 6.07H20.89l-8.595 5.18a.57.57 0 0 1-.589 0'
        />
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M2.043 5.776C2.18 5.316 2.616 5 3.111 5H20.89c.496 0 .932.317 1.069.776.136.46-.06.95-.48 1.204l-8.594 5.18a1.72 1.72 0 0 1-1.767 0L2.522 6.98a1.054 1.054 0 0 1-.479-1.204m4.943 1.367L12 10.165l5.015-3.022z'
          clipRule='evenodd'
        />
      </svg>
    </>
  )
}
IconMailDefault.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconMailDefault
